<template>
  <wo-tabs role="tablist" v-bind="modProps">
    <li v-for="item in items" :key="item.id" :label="item.label" role="presentation" @click.prevent.stop="activate(item)" :class="item.classes">
      <po-route-link v-if="item.route" :value="item.route" :link-class="linkClass" />
      <a v-else href="#" :class="linkClass" @click.stop.prevent="activate(item)">{{ item.label }}</a>
    </li>
  </wo-tabs>
</template>
<script>

import _ from 'lodash'
import modProps from '@/mixins/mod-props'

import { isRouteActive } from '@/router'

export default {
  name: 'PoTabs',
  mixins: [modProps],
  props: {
    value: undefined,
    tabs: [Array, Object]
  },
  data () {
    return {
      linkClass: 'wo-tabs__tab__link'
    }
  },
  computed: {
    items () {
      return _.map(this.tabs, this.createTab)
    }
  },
  watch: {
    '$route' () {
      const tab = _.find(this.items, i => i.route && isRouteActive(i.route))
      tab && this.activate(tab)
    }
  },
  methods: {
    createTab (option, index) {
      const fixedLabel = _.isString(option) ? option : option.name || option.label
      return {
        id: option.id || index,
        value: option,
        label: fixedLabel || this.$t(option.labelKey),
        classes: this.createClasses(option),
        route: option.route
      }
    },
    activate (item) {
      this.$emit('input', item.value)
    },
    createClasses (value) {
      return ['wo-tabs__tab', {
        'wo-tabs__tab--active': this.value === value || isRouteActive(value.route)
      }]
    }
  }
}
</script>
